import * as React from 'react';
import { GridDataHooks, GridDataKeys } from '../DataHooks';
import { classes } from '../Grid.st.css';
import { DEFAULT_COLUMN_SPAN, DEFAULT_ROW_SPAN } from '../constants';
export class Item extends React.PureComponent {
    getItemDataAttributes({ rowSpan, colSpan }) {
        return {
            [GridDataKeys.rowSpan]: rowSpan,
            [GridDataKeys.columnSpan]: colSpan,
        };
    }
    render() {
        const { children, rowSpan, colSpan } = this.props;
        return (React.createElement("li", { "data-hook": GridDataHooks.item, className: classes.item, style: {
                gridColumnEnd: `span ${colSpan}`,
                gridRowEnd: `span ${rowSpan}`,
            }, ...this.getItemDataAttributes({
                rowSpan,
                colSpan,
            }) }, children));
    }
}
Item.displayName = 'Item';
Item.defaultProps = {
    colSpan: DEFAULT_COLUMN_SPAN,
    rowSpan: DEFAULT_ROW_SPAN,
};
//# sourceMappingURL=Item.js.map